import { defineStore } from 'pinia';
import segmentApi from '@/app/shared/services/segment-service';
import { useAlertStore } from '@/app/shared/stores/alert-store';
import { DataSourceSegment } from '@/app/shared/types/datasource-segment.interface';
import { Motif } from '@/app/shared/enums/motif-enum';
import { Ref, ref } from 'vue';

export const useDataSourceSegmentStore = defineStore(
  'dataSourceSegmentStore',
  () => {
    const alertStore = useAlertStore();
    const dataSourceSegmentList: Ref<Array<DataSourceSegment>> = ref([]);

    const fetchDataSourceSegmentList = async (
      clientId: number,
      dataSourceName: string
    ) => {
      try {
        const {
          data: { data },
        } = await segmentApi.getDataSourceSegmentsByDataSourceName(
          clientId,
          dataSourceName
        );
        dataSourceSegmentList.value = data;
      } catch (e) {
        const error: any = e;
        alertStore.showNotification(
          error.message,
          'DataSourceSegmentList',
          Motif.ERROR
        );
      }
    };

    return {
      dataSourceSegmentList,
      fetchDataSourceSegmentList,
    };
  }
);
